define(['underscore','edge/platform/base/BaseCtrl'], (_,BaseCtrl)=> {
    const fn =($scope, $stateParams, $state, submissionViewModel , ModalService, MembershipService , $q, StateUtils,InMemorySession)=> {
    const ctrl = Object.create(BaseCtrl);
const flowModel = StateUtils.activeDataForState(true).flowModel;
const submissionVM = submissionViewModel();

ctrl.init = ()=> {
    $scope.accountHolder = submissionVM.draftData.accountHolder.value;

    //ENHC0011961 - commenting initialization and moved to contact page --Arpita Sengupta
    $scope.membershipDetails={
        membershipNumber : $scope.accountHolder.membershipNumber || '',
        firstName : '',
        lastName : ''
    };
    //ended

    $scope.otherProducts = {
        personalAuto : false,
        homeOwners : false,
        fire : false,
        flood : false,
        life : false,
        umbrella : false,
        renters : false,
        watercraft : false
    };


    $scope.productCode = $scope.submission.draftData.productCode;
    
    if($scope.productCode == 'Homeowners')
    {
        $scope.HOView = submissionVM.draftData.lobs.homeowners.membershipHO;
        $scope.HOView.value = $scope.HOView.value || {};

        if($scope.HOView.value){
            /*console.log("HO2",$scope.HOView.value);*/
            if($scope.HOView.otherPolicies === "true"){
                $scope.Answer = 'true' ;
            }
            $scope.otherProducts.personalAuto = $scope.HOView.value.personalAuto;
            $scope.otherProducts.homeOwners = $scope.HOView.value.homeOwners;
            $scope.otherProducts.flood = $scope.HOView.value.flood;
            $scope.otherProducts.renters = $scope.HOView.value.renters ;
            $scope.otherProducts.life = $scope.HOView.value.life;
            $scope.otherProducts.watercraft = $scope.HOView.value.waterCraft;
            $scope.otherProducts.umbrella = $scope.HOView.value.umbrella;
            $scope.otherProducts.fire = $scope.HOView.value.dwellingFire;

        }
    }
    else if($scope.productCode == 'PersonalAuto')
    {
        $scope.PAView = submissionVM.draftData.lobs.personalAuto.membershipPA;
        $scope.PAView.value = $scope.PAView.value || {};
        // ENHC0011961_EODB QnB Defaults --Arpita Sengupta
        if(submissionVM.value.quoteStatus == "Draft"){
            $scope.PAView.otherPolicies = "true";
            $scope.PAView.homeOwners = true;
        }
        //ended
        //console.log("PA1",$scope.PAView);
        
        if($scope.PAView.value){
            /*console.log("PA2",$scope.PAView.value);*/
            // ENHC0011961_EODB QnB Defaults --Arpita Sengupta
            if($scope.PAView.otherPolicies.value === "true"){
                $scope.Answer = 'true' ;
            }
            else{
                $scope.Answer = 'false';
            }
            //ended
            $scope.otherProducts.homeOwners = $scope.PAView.value.homeOwners;
            $scope.otherProducts.umbrella = $scope.PAView.umbrella;
        }
    } 
    //Datas prefill -- Arpita
    // if($scope.productCode == 'PersonalAuto' && $scope.submission.draftData.lobs.personalAuto.drivers){
    //     for(let idxDriver in  $scope.submission.draftData.lobs.personalAuto.drivers){
    //         if($scope.submission.draftData.lobs.personalAuto.drivers[idxDriver].isPrefilledDriver){
    //             let getDate = string => (([year, month, day]) => ({ year, month, day }))(string.split('-'));
    //             let temDob = InMemorySession.decryptData($scope.submission.draftData.lobs.personalAuto.drivers[idxDriver].eNCDateOfBirth).split(' ')[0];
    //             submissionVM.draftData.lobs.personalAuto.drivers.value[idxDriver].dateOfBirth = getDate(temDob);
    //         }
    //     }  
    // }   
    /*console.log("PA",$scope.PAView);
    console.log("HO",$scope.HOView);*/

    $scope.visitedNumber = false;
   /* $scope.Answer = false;*/
    $scope.activeSection = 'new';

    // For CHG0030501
    /*$scope.policyInfoPaymentMethod = submissionVM.draftData.policyInfoPaymentMethod;
    $scope.policyInfoDocumentDeliveryMethod = submissionVM.draftData.policyInfoDocumentDeliveryMethod;
    $scope.policyInfoPaymentMethodOptions = _.filter(submissionVM.draftData.policyInfoPaymentMethod.aspects.availableValues,(options) => {
        if($scope.productCode == 'PersonalAuto'){
            const availablepolicyInofPaymentMethods = ["paid_in_full","billbymail","recurring"];
            return availablepolicyInofPaymentMethods.indexOf(options.code) != -1;
        }else{
            return options;
        }

    });

   $scope.policyInfoDocumentDeliveryOptions =  _.filter(submissionVM.draftData.policyInfoDocumentDeliveryMethod.aspects.availableValues,(options) => {
            const availableDocumentDeliveryOptions = ["email","mail"];
            return availableDocumentDeliveryOptions.indexOf(options.code) != -1;
    });*/
};


// ENHC0011961 - commenting warning message from membership page
ctrl.showMemberWarning = function (){

    if(null != $scope.membershipDetails.membershipNumber && $scope.membershipDetails.membershipNumber != '' && $scope.membershipDetails.membershipNumber.length !=16) {

        ModalService.showCustomInfo('quoteandbind.controllers.ModalService.Attention',
            'quoteandbind.controllers.MembershipCtrl.AttentionMessage');
    }

};
// ended

ctrl.next = function (form) {
    if($scope.productCode == 'Homeowners')
    {
        if($scope.Answer) {
            $scope.HOView.otherPolicies = $scope.Answer;
            $scope.HOView.personalAuto = $scope.otherProducts.personalAuto;
            $scope.HOView.homeOwners = $scope.otherProducts.homeOwners;
            $scope.HOView.flood = $scope.otherProducts.flood;
            $scope.HOView.renters = $scope.otherProducts.renters;
            $scope.HOView.life = $scope.otherProducts.life;
            $scope.HOView.waterCraft = $scope.otherProducts.watercraft;
            $scope.HOView.umbrella = $scope.otherProducts.umbrella;
            $scope.HOView.dwellingFire = $scope.otherProducts.fire;
        }
        else {
            $scope.Answer = '';
        }
    }
    else if($scope.productCode == 'PersonalAuto')
    {
        if($scope.Answer) {
            $scope.PAView.otherPolicies = $scope.Answer;
            $scope.PAView.homeOwners = $scope.otherProducts.homeOwners;
            $scope.PAView.umbrella = $scope.otherProducts.umbrella;
        }
        else {
            $scope.Answer = '';
        }
    }

//  CHG0031104 - Add OMEGA QnB link to SECU’s website
//  AB - April 05, 2020
//
    if (!$scope.accountHolder.isCreditUnionMember){
        $scope.accountHolder.joinedYearCreditUnionMembership = null
    }

    submissionVM.draftData.insuranceScoreAgreed = true;
    submissionVM.draftData.policyInfoPaymentMethod.value = "recurring";
    submissionVM.draftData.policyInfoDocumentDeliveryMethod.value = "email";
    form.submitted = true;
    flowModel.next(submissionVM);
};
ctrl.previous = function () {
    flowModel.previous(submissionVM);
};
ctrl.cancel = function () {
    flowModel.cancel(submissionVM);
};

ctrl.membership= function(form) {
    form.submitted = true;
    $scope.accountHolder.isFairCreditReportingAct = true;
    // ENHC0011961 no validation required and default quote as member
    if($scope.productCode == 'Homeowners'){
        if ($scope.membershipDetails.membershipNumber != null && $scope.membershipDetails.membershipNumber != '' && $scope.membershipDetails.membershipNumber.length == '16'  ) {

            var membershipPromise = MembershipService.isMember('quoteandbind', $scope.membershipDetails);
            ModalService.showProgressDialog('quoteandbind.controllers.MembershipCtrl.Checking for membership', membershipPromise);

            membershipPromise.then(membershipResp => {

                if( membershipResp[0].membershipStatus &&
                    membershipResp[0].firstName && membershipResp[0].lastName
                ){
                    $scope.accountHolder.isMember = true;
                    $scope.accountHolder.membershipNumber = membershipResp[0].membershipNumber;
                    $scope.accountHolder.joinedYear = membershipResp[0].originalJoinYear;
                    $scope.accountHolder.membershipType = membershipResp[0].serviceLevel;
                    $scope.accountHolder.membershipStatus = membershipResp[0].membershipStatus;

                }else{
                    $scope.accountHolder.isMember = false;
                }



                ctrl.next(form);

            }).catch(() => {
                const errorPromise = ModalService.showError(
                    'quoteandbind.controllers.MembershipCtrl.Error',
                    'quoteandbind.controllers.MembershipCtrl.PC system down error'
                );

            });
            ctrl.next(form);

        }else
        {
            $scope.accountHolder.isMember = false;
            ctrl.next(form);
        }
    }
    else{
        ctrl.next(form);
    }
};


return ctrl.create($scope);
};
fn.$inject = ['$scope', '$stateParams', '$state', 'submissionViewModel','ModalService', 'MembershipService', '$q', 'StateUtils','InMemorySession'];

return fn;
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/common/controllers/MembershipCtrl.js
 **/